import React, { memo, useCallback } from 'react';

import { ClipButtonTrackingProperties } from 'types/clips';
import { trackEvent } from '@surfline/web-common';
import ClipButton from '../ClipButton';
import styles from './SmartClipsOverlayPrompt.module.scss';

interface Props {
  supportsSmartRewinds: boolean;
  clipsButtonUrl: string;
  clipButtonSegmentProperties: ClipButtonTrackingProperties;
  disabled: boolean;
}

const SmartClipsOverlayPrompt = ({
  clipButtonSegmentProperties,
  supportsSmartRewinds,
  clipsButtonUrl,
  disabled,
}: Props) => {
  const [clipsLoading, setClipsLoading] = React.useState(false);

  const onClickHandler = useCallback(() => {
    if (!disabled)
      trackEvent('Clicked Smart Clips', {
        ...clipButtonSegmentProperties,
        clickedCamPlayerPrompt: true,
      });
    setClipsLoading(true);
  }, [disabled, clipButtonSegmentProperties, setClipsLoading]);

  return (
    <div className={styles.smartClipsOverlayPrompt}>
      <div className={styles.promptText}>Looking for your waves?</div>
      <div>
        <ClipButton
          clipsLoading={clipsLoading}
          onClick={onClickHandler}
          supportsSmartRewinds={supportsSmartRewinds}
          href={clipsButtonUrl}
          btnClassName={styles.clipButton}
          dataTestId="clips-button-prompt"
        />
      </div>
    </div>
  );
};

export default memo(SmartClipsOverlayPrompt);
